/*-----------------------------------------------------------------------------
|> TVGuide Channel Component
|------------------------------------------------------------------------------
|
| Render a single channel item with schedules
|
-----------------------------------------------------------------------------*/
<template>
    <div
        :class="`vw-guide-channel-item guide-channel channel-${data.channel}`"
        :style="{ backgroundColor: isAds ? bgColor : ''}"
        @click="playChannel"
    >
        <div class="channel" :style="{ backgroundColor: isAds ? bgColor : ''}">
            <div class="guide-channel-number">
                <span>
                    {{ channelNumber }}
                </span>
            </div>

            <div class="guide-channel-logo">
                <img :src="channelLogo" :alt="`Logo of channel ${data.channel}`">
            </div>
        </div>

        <schedules :data="airings" :swipe-handler="swipeHandler" />
    </div>
</template>

<script>
import dayjs from 'dayjs';

import Schedules from '@components/iptv/ChannelSchedules.vue';
import {isNumber} from 'lodash';

export default {
    components: { Schedules },
    props: {
        data: { type: Object, required: true },
        startTime: { type: String, required: true },
        swipeHandler: { type: Function, required: true },
    },
    computed: {
        /**
         * Returns only shows which `endTime` hasn't pass the client's specified `startTime`
         */
        airings() {
            return this.data.airings
                .filter((airing) => {
                    return dayjs(airing.endTime)
                        .diff(dayjs(this.startTime), 'minutes') >= 0;
                });
        },
        channelLogo() {
            return this.data.logo || this.$root.defaultLogo;
        },
        channelNumber() {
            return isNumber(this.data.channel) ? this.data.channel : (this.data.channel.replace(/^0/, '') || '');
        },
        isAds() {
            return this.data.isAds ? true : false;
        },
        bgColor() {
            return this.data.bgColor || '';
        }
    },
    mounted() {
        const currentChannel = document.querySelector('[data-order="0"]');

        if (!currentChannel.classList.contains('channel-current')) {
            currentChannel.classList.add('channel-current');
        }
    },
    methods: {
        playChannel(event) {
            // `event` is the native DOM event
            if (event) {
                if (this.data.isAds) {
                    window.open(this.data.streaming_url, '_blank');
                } else {
                    this.$root.$emit('playChannel', this.data.channel);
                }
            }
        }
    }
}
</script>
